import React from 'react';
import PropTypes from 'prop-types';

import CERTIFICATION_ICONS from 'constants/certificationIcons';
import { CertificationBadgeIcon } from 'components/CertificationBadge';

const ICON_LIST = Object.values(CERTIFICATION_ICONS).sort();

const BadgeEditorIconList = ({
  onChange,
  selectSafeIconColor,
  disabled = false,
}) => {
  return (
    <div className="d-f fd-c mb-32">
      <div className="lh-24 c-brand-gray-darker">
        {t('certifications.badge_editor.icon')}
      </div>
      <ul className="d-f ai-c fw-w ml-1">
        {ICON_LIST.map(iconName => (
          <button
            key={iconName}
            type="button"
            disabled={disabled}
            className="u-resetBtn z-0 focus:z-10"
            onClick={() => onChange(iconName)}
          >
            <li
              style={{
                background: selectSafeIconColor({
                  colorType: 'backgroundColor',
                  iconName,
                }),
              }}
              className="bg-white h-40 w-40 ls-none d-f ai-c jc-c mt-1 mr-1 o-1 o-gray-light"
            >
              <CertificationBadgeIcon
                name={iconName}
                height="24px"
                width="24px"
                fill={selectSafeIconColor({
                  colorType: 'foregroundColor',
                  iconName,
                })}
              />
            </li>
          </button>
        ))}
      </ul>
    </div>
  );
};

BadgeEditorIconList.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  selectSafeIconColor: PropTypes.func,
};

export default BadgeEditorIconList;
